<template>
  <div class="tw-w-full">
    <button
      type="submit"
      class="tw-w-full tw-flex tw-justify-center tw-whitespace-nowrap tw-bg-primary tw-rounded tw-font-medium tw-py-3.5 tw-px-8"
      :class="[
        title == 'Decline' ||
        title == 'Yes, Decline' ||
        title.includes('Terminate')
          ? 'tw-bg-error-light tw-text-error hover:tw-text-white hover:tw-bg-error'
          : '',
        title == 'Cancel' || title.includes('Edit')
          ? 'tw-bg-primary-light tw-text-secondary'
          : 'tw-text-white',
      ]"
      :disabled="loading || disabled"
    >
      <img
        v-if="title === 'Fund Wallet'"
        class="tw-hidden sm:tw-block tw-mr-2"
        src="@/assets/img/plus-icon.svg"
        alt="plus"
      />
      <span v-show="!loading">{{ title }}</span>
      <img
        v-show="loading"
        class="tw-m-auto"
        src="@/assets/img/spinner.svg"
        alt="animated spinner"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: "OnboardingBtn",

  emits: ["button-click"],

  props: {
    title: { type: String, default: () => "", required: true },
    loading: { type: Boolean, default: () => false },
    disabled: { type: Boolean, default: () => false },
  },
};
</script>

<style lang="scss" scoped>
</style>
